(
    function (skyward, $, undefined)
    {
        skyward.ajaxrepeater = skyward.ajaxrepeater || {};

        var init = function (selector)
        {
            $(selector).find(".ajaxRepeaterPlaceHolder").each(function ()
            {
                var placeHolder = $(this);
                skyward.ajaxrepeater.load(placeHolder);
            });
        };

        skyward.ajaxrepeater.load = function (placeHolder)
        {
            var data = placeHolder.data();

            if (!data.templateModule || !data.templateController || !data.templateAction || !data.primaryKey)
            {
                return;
            }

            placeHolder.text("Loading...");

            $.when(skyward.window.loadContent(placeHolder.attr("id"), data.templateModule, data.templateController, data.templateAction, data.primaryKey, data.postdata).done(function ()
            {
                placeHolder.trigger("ajaxRepeaterTemplateLoaded", placeHolder);
            }));
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);